import client from "../libs/HttpClient";

class TutorialServices {
  static tutorialList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/tutorials?page=${page_no}`, request);
  }
  static addTutorial(request) {
    return client.post(`/add-tutorial`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static updateTutorial(request) {
    return client.post(`/edit-tutorial`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static viewTutorial(params) {
    return client.get(`get-tutorial`, { params });
  }
  static deleteTutorial(params) {
    return client.delete(`delete-tutorial`, { params });
  }
  static getProductList(request) {
    return client.get(`get-product-list`, request);
  }
}
export { TutorialServices };
